(() => {
  document.addEventListener("DOMContentLoaded", () => {
    const el = document.querySelector(".js-top-brand-swiper");
    if (!el || typeof Swiper === "undefined") return;

    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 32,
      loop: true,
      speed: 600,
      breakpoints: {
        768: {
          slidesPerView: 3,
          // spaceBetween: 64,
        },
        1000: {
          slidesPerView: 5,
          spaceBetween: 64,
        },
      },
      pagination: {
        el: ".top_brand_pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".top_brand_next",
        prevEl: ".top_brand_prev",
      },
    });
  });
})();
